/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Link_ModelsInputs */

const en_directory_footer_link_models = /** @type {(inputs: Directory_Footer_Link_ModelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Models`)
};

const zh_directory_footer_link_models = /** @type {(inputs: Directory_Footer_Link_ModelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`模型广场`)
};

/**
* | output |
* | --- |
* | "Models" |
*
* @param {Directory_Footer_Link_ModelsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_link_models = /** @type {((inputs?: Directory_Footer_Link_ModelsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Link_ModelsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_link_models(inputs)
	return zh_directory_footer_link_models(inputs)
});
export { directory_footer_link_models as "directory.footer.link_models" }